<template>
  <div style="width:100%; height:100%;">
    <general-dialog v-model="modal" :title="popupTitle" :buttons="buttons">
      <v-card flat>
        <v-card-text>
          <v-form>
            <v-row>
              <v-col cols="12">
                <p>마지막 비밀번호 변경후 180일이 지났습니다.</p>
                <p>비밀번호 변경을 권장드립니다. 변경하시겠습니까?</p>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
      </v-card>
    </general-dialog>
    <!--<v-dialog v-model="component_show" width="40%">
      <v-card class="top_title"> &nbsp; 공지사항</v-card>
      <v-card>
      <span>
        &nbsp; <input type="checkbox" :id="'chkToday'"> &nbsp;5일동안 열지 않음 &nbsp;
        <v-btn varient="plain" size="small" @click="closeLayer"> 닫기</v-btn>
      </span>
      </v-card>
      <div class="main_content">
        <img src="@/assets/image/popup.jpg" width="100%">
      </div>
    </v-dialog>-->
    <v-img min-width="1024" :aspect-ratio="1920 / 1080" :src="mapImg">
      <v-img
        v-show="false"
        src="@/assets/image/monitoring/mapline_jeju.png"
        style="position:absolute; left:0%; top:0%;"
        width="100%"
      ></v-img>
      <v-img
        v-show="false"
        src="@/assets/image/monitoring/mapline_busan.png"
        style="position:absolute; left:0%; top:0%;"
        width="100%"
      ></v-img>
      <v-img
        v-show="false"
        src="@/assets/image/monitoring/mapline_daegu.png"
        style="position:absolute; left:0%; top:0%;"
        width="100%"
      ></v-img>
      <v-img
        v-show="false"
        src="@/assets/image/monitoring/mapline_daejeon.png"
        style="position:absolute; left:0%; top:0%;"
        width="100%"
      ></v-img>
      <v-img
        v-show="false"
        src="@/assets/image/monitoring/mapline_gwangju.png"
        style="position:absolute; left:0%; top:0%;"
        width="100%"
      ></v-img>
      <v-img
        v-show="false"
        src="@/assets/image/monitoring/mapline_incheon.png"
        style="position:absolute; left:0%; top:0%;"
        width="100%"
      ></v-img>
      <v-img
        v-show="false"
        src="@/assets/image/monitoring/mapline_sejong.png"
        style="position:absolute; left:0%; top:0%;"
        width="100%"
      ></v-img>
      <v-img
        v-show="false"
        src="@/assets/image/monitoring/mapline_seoul.png"
        style="position:absolute; left:0%; top:0%;"
        width="100%"
      ></v-img>
      <v-img
        v-show="false"
        src="@/assets/image/monitoring/mapline_ulsan.png"
        style="position:absolute; left:0%; top:0%;"
        width="100%"
      ></v-img>

      <stock-block
        :errorCount="viewSidoData[11] ? viewSidoData[11].errorCount : 0"
        :errorList="viewSidoData[11] ? viewSidoData[11].errorList : []"
        :faultCount="viewSidoData[11] ? viewSidoData[11].faultCount : 0"
        :faultList="viewSidoData[11] ? viewSidoData[11].faultList : []"
        :runCount="
          viewSidoData[11]
            ? viewSidoData[11].runCount + viewSidoData[11].pauseCount
            : 0
        "
        :runList="viewSidoData[11] ? viewSidoData[11].runList : []"
        :title="viewSidoData[11] ? viewSidoData[11].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="11"
        style="position: absolute; top:10%; left:5%;"
        @openPop="openPopup"
      ></stock-block>
      <stock-block
        :errorCount="viewSidoData[28] ? viewSidoData[28].errorCount : 0"
        :errorList="viewSidoData[28] ? viewSidoData[28].errorList : []"
        :faultCount="viewSidoData[28] ? viewSidoData[28].faultCount : 0"
        :faultList="viewSidoData[28] ? viewSidoData[28].faultList : []"
        :runCount="
          viewSidoData[28]
            ? viewSidoData[28].runCount + viewSidoData[28].pauseCount
            : 0
        "
        :runList="viewSidoData[28] ? viewSidoData[28].runList : []"
        :title="viewSidoData[28] ? viewSidoData[28].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="28"
        style="position: absolute; top:26%; left:5%;"
        @openPop="openPopup"
      ></stock-block>
      <stock-block
        :errorCount="viewSidoData[36] ? viewSidoData[36].errorCount : 0"
        :errorList="viewSidoData[36] ? viewSidoData[36].errorList : []"
        :faultCount="viewSidoData[36] ? viewSidoData[36].faultCount : 0"
        :faultList="viewSidoData[36] ? viewSidoData[36].faultList : []"
        :runCount="
          viewSidoData[36]
            ? viewSidoData[36].runCount + viewSidoData[36].pauseCount
            : 0
        "
        :runList="viewSidoData[36] ? viewSidoData[36].runList : []"
        :title="viewSidoData[36] ? viewSidoData[36].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="36"
        style="position: absolute; top:42%; left:5%;"
        @openPop="openPopup"
      ></stock-block>
      <stock-block
        :errorCount="viewSidoData[30] ? viewSidoData[30].errorCount : 0"
        :errorList="viewSidoData[30] ? viewSidoData[30].errorList : []"
        :faultCount="viewSidoData[30] ? viewSidoData[30].faultCount : 0"
        :faultList="viewSidoData[30] ? viewSidoData[30].faultList : []"
        :runCount="
          viewSidoData[30]
            ? viewSidoData[30].runCount + viewSidoData[30].pauseCount
            : 0
        "
        :runList="viewSidoData[30] ? viewSidoData[30].runList : []"
        :title="viewSidoData[30] ? viewSidoData[30].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="30"
        style="position: absolute; top:58%; left:5%;"
        @openPop="openPopup"
      ></stock-block>

      <stock-block
        :errorCount="viewSidoData[50] ? viewSidoData[50].errorCount : 0"
        :errorList="viewSidoData[50] ? viewSidoData[50].errorList : []"
        :faultCount="viewSidoData[50] ? viewSidoData[50].faultCount : 0"
        :faultList="viewSidoData[50] ? viewSidoData[50].faultList : []"
        :runCount="
          viewSidoData[50]
            ? viewSidoData[50].runCount + viewSidoData[50].pauseCount
            : 0
        "
        :runList="viewSidoData[50] ? viewSidoData[50].runList : []"
        :title="viewSidoData[50] ? viewSidoData[50].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="50"
        style="position: absolute; bottom:42.5%; left:15%;"
        @openPop="openPopup"
      ></stock-block>

      <stock-block
        :errorCount="viewSidoData[41] ? viewSidoData[41].errorCount : 0"
        :errorList="viewSidoData[41] ? viewSidoData[41].errorList : []"
        :faultCount="viewSidoData[41] ? viewSidoData[41].faultCount : 0"
        :faultList="viewSidoData[41] ? viewSidoData[41].faultList : []"
        :runCount="
          viewSidoData[41]
            ? viewSidoData[41].runCount + viewSidoData[41].pauseCount
            : 0
        "
        :runList="viewSidoData[41] ? viewSidoData[41].runList : []"
        :title="viewSidoData[41] ? viewSidoData[41].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="41"
        style="position: absolute; top:15%; left:32%;"
        @openPop="openPopup"
      ></stock-block>
      <stock-block
        :errorCount="viewSidoData[43] ? viewSidoData[43].errorCount : 0"
        :errorList="viewSidoData[43] ? viewSidoData[43].errorList : []"
        :faultCount="viewSidoData[43] ? viewSidoData[43].faultCount : 0"
        :faultList="viewSidoData[43] ? viewSidoData[43].faultList : []"
        :runCount="
          viewSidoData[43]
            ? viewSidoData[43].runCount + viewSidoData[43].pauseCount
            : 0
        "
        :runList="viewSidoData[43] ? viewSidoData[43].runList : []"
        :title="viewSidoData[43] ? viewSidoData[43].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="43"
        style="position: absolute; top:34%; left:38%;"
        @openPop="openPopup"
      ></stock-block>
      <!-- 경상북도 -->
      <stock-block
        :errorCount="viewSidoData[47] ? viewSidoData[47].errorCount : 0"
        :errorList="viewSidoData[47] ? viewSidoData[47].errorList : []"
        :faultCount="viewSidoData[47] ? viewSidoData[47].faultCount : 0"
        :faultList="viewSidoData[47] ? viewSidoData[47].faultList : []"
        :runCount="
          viewSidoData[47]
            ? viewSidoData[47].runCount + viewSidoData[47].pauseCount
            : 0
        "
        :runList="viewSidoData[47] ? viewSidoData[47].runList : []"
        :title="viewSidoData[47] ? viewSidoData[47].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="47"
        style="position: absolute; top:38%; left:47%;"
        @openPop="openPopup"
      ></stock-block>
      <stock-block
        :errorCount="viewSidoData[44] ? viewSidoData[44].errorCount : 0"
        :errorList="viewSidoData[44] ? viewSidoData[44].errorList : []"
        :faultCount="viewSidoData[44] ? viewSidoData[44].faultCount : 0"
        :faultList="viewSidoData[44] ? viewSidoData[44].faultList : []"
        :runCount="
          viewSidoData[44]
            ? viewSidoData[44].runCount + viewSidoData[44].pauseCount
            : 0
        "
        :runList="viewSidoData[44] ? viewSidoData[44].runList : []"
        :title="viewSidoData[44] ? viewSidoData[44].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="44"
        style="position: absolute; top:36%; left:27%;"
        @openPop="openPopup"
      ></stock-block>
      <stock-block
        :errorCount="viewSidoData[52] ? viewSidoData[52].errorCount : 0"
        :errorList="viewSidoData[52] ? viewSidoData[52].errorList : []"
        :faultCount="viewSidoData[52] ? viewSidoData[52].faultCount : 0"
        :faultList="viewSidoData[52] ? viewSidoData[52].faultList : []"
        :runCount="
          viewSidoData[52]
            ? viewSidoData[52].runCount + viewSidoData[52].pauseCount
            : 0
        "
        :runList="viewSidoData[52] ? viewSidoData[52].runList : []"
        :title="viewSidoData[52] ? viewSidoData[52].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="52"
        style="position: absolute; bottom:36%; left:33%;"
        @openPop="openPopup"
      ></stock-block>
      <!-- 전남광주통합특별자치시 -->
      <stock-block
        :errorCount="viewSidoData[12] ? viewSidoData[12].errorCount : 0"
        :errorList="viewSidoData[12] ? viewSidoData[12].errorList : []"
        :faultCount="viewSidoData[12] ? viewSidoData[12].faultCount : 0"
        :faultList="viewSidoData[12] ? viewSidoData[12].faultList : []"
        :runCount="
          viewSidoData[12]
            ? viewSidoData[12].runCount + viewSidoData[12].pauseCount
            : 0
        "
        :runList="viewSidoData[12] ? viewSidoData[12].runList : []"
        :title="viewSidoData[12] ? viewSidoData[12].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="12"
        style="position: absolute; bottom:22%; left:27%;"
        @openPop="openPopup"
      ></stock-block>

      <stock-block
        :errorCount="viewSidoData[48] ? viewSidoData[48].errorCount : 0"
        :errorList="viewSidoData[48] ? viewSidoData[48].errorList : []"
        :faultCount="viewSidoData[48] ? viewSidoData[48].faultCount : 0"
        :faultList="viewSidoData[48] ? viewSidoData[48].faultList : []"
        :runCount="
          viewSidoData[48]
            ? viewSidoData[48].runCount + viewSidoData[48].pauseCount
            : 0
        "
        :runList="viewSidoData[48] ? viewSidoData[48].runList : []"
        :title="viewSidoData[48] ? viewSidoData[48].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="48"
        style="position: absolute; bottom:32%; left:42%;"
        @openPop="openPopup"
      ></stock-block>
      <!-- 강원특별자치도 -->
      <stock-block
        :errorCount="viewSidoData[51] ? viewSidoData[51].errorCount : 0"
        :errorList="viewSidoData[51] ? viewSidoData[51].errorList : []"
        :faultCount="viewSidoData[51] ? viewSidoData[51].faultCount : 0"
        :faultList="viewSidoData[51] ? viewSidoData[51].faultList : []"
        :runCount="
          viewSidoData[51]
            ? viewSidoData[51].runCount + viewSidoData[51].pauseCount
            : 0
        "
        :runList="viewSidoData[51] ? viewSidoData[51].runList : []"
        :title="viewSidoData[51] ? viewSidoData[51].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="51"
        style="position: absolute; top:17%; left:42%;"
        @openPop="openPopup"
      ></stock-block>

      <!-- 대구 -->
      <stock-block
        :errorCount="viewSidoData[27] ? viewSidoData[27].errorCount : 0"
        :errorList="viewSidoData[27] ? viewSidoData[27].errorList : []"
        :faultCount="viewSidoData[27] ? viewSidoData[27].faultCount : 0"
        :faultList="viewSidoData[27] ? viewSidoData[27].faultList : []"
        :runCount="
          viewSidoData[27]
            ? viewSidoData[27].runCount + viewSidoData[27].pauseCount
            : 0
        "
        :runList="viewSidoData[27] ? viewSidoData[27].runList : []"
        :title="viewSidoData[27] ? viewSidoData[27].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="27"
        style="position: absolute; top:26%; left:59.5%;"
        @openPop="openPopup"
      ></stock-block>
      <stock-block
        :errorCount="viewSidoData[31] ? viewSidoData[31].errorCount : 0"
        :errorList="viewSidoData[31] ? viewSidoData[31].errorList : []"
        :faultCount="viewSidoData[31] ? viewSidoData[31].faultCount : 0"
        :faultList="viewSidoData[31] ? viewSidoData[31].faultList : []"
        :runCount="
          viewSidoData[31]
            ? viewSidoData[31].runCount + viewSidoData[31].pauseCount
            : 0
        "
        :runList="viewSidoData[31] ? viewSidoData[31].runList : []"
        :title="viewSidoData[31] ? viewSidoData[31].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="31"
        style="position: absolute; top:42%; left:59.5%;"
        @openPop="openPopup"
      ></stock-block>
      <stock-block
        :errorCount="viewSidoData[26] ? viewSidoData[26].errorCount : 0"
        :errorList="viewSidoData[26] ? viewSidoData[26].errorList : []"
        :faultCount="viewSidoData[26] ? viewSidoData[26].faultCount : 0"
        :faultList="viewSidoData[26] ? viewSidoData[26].faultList : []"
        :runCount="
          viewSidoData[26]
            ? viewSidoData[26].runCount + viewSidoData[26].pauseCount
            : 0
        "
        :runList="viewSidoData[26] ? viewSidoData[26].runList : []"
        :title="viewSidoData[26] ? viewSidoData[26].sidoName : ''"
        :visible="sidoFlag"
        sidoCode="26"
        style="position: absolute; top:58%; left:59.5%;"
        @openPop="openPopup"
      ></stock-block>
      <v-card class="pa-1" style="position:absolute;top:2%;left:1%;">
        <v-card-text class="py-0">
          <v-row>
            <v-avatar color="green" size="26"></v-avatar>
            <span>&nbsp;&nbsp;</span>
            <span style="color: #4CAF50" class="text-subtitle-2">가동</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <v-avatar color="red" size="26"></v-avatar>
            <span>&nbsp;&nbsp;</span>
            <span style="color: #F44336">고장</span>
            <span>&nbsp;&nbsp;&nbsp;&nbsp;</span>
            <v-avatar color="yellow darken-2" size="26"></v-avatar>
            <span>&nbsp;&nbsp;</span>
            <span style="color: #FBC02D">통신이상</span>
          </v-row>
        </v-card-text>
      </v-card>
    </v-img>
    <v-card
      class="card--group"
      max-width="475px"
      min-width="370px"
      style="position: fixed; top:12%; right:1%;"
      width="25%"
    >
      <v-card-actions class="pb-0">
        <v-radio-group
          dark
          v-model="customerType"
          class="mt-0"
          hide-details
          row
          @change="changeCustomerType"
        >
          <v-radio label="전체" value="A"></v-radio>
          <v-radio label="프리미엄" value="P"></v-radio>
        </v-radio-group>
      </v-card-actions>
      <v-card-actions class="align-center pb-0">
        <v-text-field
          dark
          v-model="searchParam"
          class="mt-1 pr-2"
          dense
          hide-details
          outlined
          placeholder="사이트명을 입력하세요"
          @keyup.enter="
            toggleEvent = !toggleEvent
            paramStatus = 'search'
            popup = true
          "
        ></v-text-field>
        <v-btn
          dark
          color="#0784F2"
          height="40"
          min-width="48"
          width="48"
          @click="
            toggleEvent = !toggleEvent
            paramStatus = 'search'
            popup = true
          "
        >
          <v-icon>mdi-magnify</v-icon>
        </v-btn>
      </v-card-actions>
      <v-card-text class="py-0 px-1">
        <v-container class="py-1 px-3">
          <v-row>
            <v-col class="pa-1" cols="6">
              <text-card
                :value="Math.floor(siteTotal.totalCapacity / 1000)"
                color="#FFD754"
                title="총 사이트 용량"
                unit="MW"
              ></text-card>
            </v-col>
            <v-col class="pa-1" cols="6">
              <gauge-card
                :flag="flag"
                :max="Math.round((siteTotal.totalCapacity * 1.1) / 1000)"
                :value="
                  isNaN(siteTotal.pvpcsPac)
                    ? 0
                    : Math.round(siteTotal.pvpcsPac / 1000)
                "
                color="#90F072"
                title="발전량"
                unit="MW"
              ></gauge-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pa-1" cols="6">
              <text-card
                :value="Math.round(siteTotal.pvpcsDailyP / 1000)"
                color="#00FFFA"
                title="당일 발전량"
                unit="MWH"
              ></text-card>
            </v-col>
            <v-col class="pa-1" cols="6">
              <gauge-card
                :flag="flag"
                :max="9"
                :value="siteTotal.dailyTime"
                color="#FFD754"
                title="발전 시간"
                unit="hr"
              ></gauge-card>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pa-1" cols="6">
              <state-table
                :err-list="errorSiteList"
                :err-val="siteTotal.faultCount"
                :fault-list="faultSiteList"
                :run-val="siteTotal.runCount + siteTotal.pauseCount"
                :state-value="siteTotal.totalCount"
                :str-val="siteTotal.errorCount"
                :visible="true"
                stateName="총 사이트 수"
                title="사이트 현황"
              ></state-table>
            </v-col>
            <v-col class="pa-1" cols="6">
              <state-table
                :err-list="errorSiteList"
                :err-val="inverterTotal.faultCount"
                :fault-list="faultSiteList"
                :run-val="inverterTotal.runCount + inverterTotal.pauseCount"
                :state-value="inverterTotal.totalCount"
                :str-val="inverterTotal.errorCount"
                :visible="true"
                stateName="총 인버터 수"
                title="인버터 현황"
              ></state-table>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
    <v-dialog v-model="popup" max-width="450px" persistent>
      <detail-status-popup
        :detail="paramTitle"
        :list="paramList"
        :status="paramStatus"
        :text.sync="searchParam"
        :toggle-event="toggleEvent"
        @closeDetailPop="popup = false"
      ></detail-status-popup>
    </v-dialog>
  </div>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
import { dateRenew } from '@/api/common/login'

import StockBlock from '@/components/monitoring/StockBlock.vue'
import StateTable from '@/components/monitoring/StateTable.vue'
import localStore from '@/utils/localStore'
import GeneralDialog from '@/components/dialogSet/GeneralDialog'
import GaugeCard from '@/components/monitoring/GaugeCard'
import DetailStatusPopup from '@/components/monitoring/DetailStatusPopup'
import TextCard from '@/components/monitoring/TextCard'
import { getMonitoringTotal } from '@/api/monitoring/monitoring'
import Message from '@/utils/message'

export default {
  name: 'CenterAS',
  components: {
    StockBlock,
    StateTable,
    GaugeCard,
    DetailStatusPopup,
    TextCard,
    GeneralDialog
  },
  mixins: [],
  data() {
    return {
      row_num: 0,
      component_key: 1,
      layer_type: 'SummaryPopup',
      component_show: false,
      toggleEvent: true,
      customerType: 'A',
      visibility: 'A',
      count: 0,
      modal: false,
      popupTitle: '비밀번호 변경',
      buttons: [
        {
          title: '변경',
          color: 'primary',
          class: 'white--text',
          handler: () => {
            this.closePopup({ ok: true })
          }
        },
        {
          title: '다음에 변경하기',
          text: true,
          handler: () => {
            this.closePopup({ ok: false })
          }
        }
      ],
      siteTotal: {
        dailyTime: 0,
        errorCount: 0,
        expectPrice: 0,
        faultCount: 0,
        pauseCount: 0,
        pvpcsDailyP: 0,
        pvpcsPac: 0,
        runCount: 0,
        totalCapacity: 0,
        totalCount: 0
      },
      inverterTotal: {
        dailyTime: 0,
        errorCount: 0,
        expectPrice: 0,
        faultCount: 0,
        pauseCount: 0,
        pvpcsDailyP: 0,
        pvpcsPac: 0,
        runCount: 0,
        totalCapacity: 0,
        totalCount: 0
      },
      faultList: [],
      errorList: [],
      runList: [],
      base_date: {
        y: '',
        m: '',
        d: ''
      },
      sites: [],
      sidoData: [],
      sidoCodeList: [
        '11',
        '12',
        '26',
        '27',
        '28',
        '30',
        '31',
        '36',
        '41',
        '51',
        '43',
        '44',
        '52',
        '47',
        '48',
        '50'
      ],
      popup: false,
      sidoFlag: [],
      paramTitle: '',
      paramStatus: '',
      paramList: [],
      searchParam: '',
      flag: 0,
      intervalHandler: null
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
    this.$store.dispatch('SetTabIndex', 0)
    this.$store.dispatch('SetLoadingDialog', true)
  },
  mounted() {
    this.getMonitorData()
    this.intervalHandler = setInterval(() => {
      this.getMonitorData()
    }, 60000 * 2)
    window.addEventListener('resize', this.setHeightOfImage)
    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
    this.popup2()
    var pwChangeYN = localStore.get('pw_change')
    if (pwChangeYN === 'Y') {
      this.modal = true
    } else {
    }
  },
  activated() {
    console.log('activated')
    this.getMonitorData()
    if (this.intervalHandler === null) {
      this.intervalHandler = setInterval(() => {
        this.getMonitorData()
      }, 60000 * 2)
    }
  },
  deactivated() {
    // console.log('deactivated')
    clearInterval(this.intervalHandler)
  },
  computed: {
    mapImg() {
      if (this.$vuetify.theme.dark) {
        return require('@/assets/image/monitoring/map_white.png')
      } else {
        return require('@/assets/image/monitoring/map_dark.png')
      }
    },
    imageFlag(flag) {
      return flag
    },
    // 값이 자주 변경됨에 따라, 관련되어 데이터 혹은 view가 바뀌어야 할 경우 사용
    // method를 바로 연결하면 tic 단위로 계속 실행되기 때문에, 값이 변경할 때만 수행되고,
    // cache로 남는 computed를 활용하는 것이 성능에 좋음
    total() {
      let pvpcsPac = 0
      let pvpcsDailyP = 0
      let time = 0
      let capacity = 0
      let price = 0
      this.sites.forEach(x => {
        pvpcsPac += x.PVPCS_Pac
        pvpcsDailyP += x.PVPCS_Daily_P
        price += x.expectPrice
        capacity += x.totalCapacity
      })
      time = (pvpcsDailyP / capacity).toFixed(2)
      pvpcsPac = pvpcsPac.toFixed(2)
      pvpcsDailyP = pvpcsDailyP.toFixed(2)
      price = price.toFixed(0)
      return {
        pvpcsPac,
        pvpcsDailyP,
        price,
        time,
        capacity
      }
    },
    viewSidoData() {
      return this.sidoData
    },
    errorSiteList() {
      let result = []
      for (let key in this.sidoData) {
        if (this.sidoData[key].errorList.length > 0) {
          result.push(...this.sidoData[key].errorList)
        }
      }
      return result
    },
    faultSiteList() {
      let result = []
      for (let key in this.sidoData) {
        if (this.sidoData[key].faultList.length > 0) {
          result.push(...this.sidoData[key].faultList)
        }
      }
      return result
    }
  },
  watch: {},
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    changeCustomerType() {
      this.$store.dispatch('SetLoadingDialog', true)
      this.getMonitorData()
    },
    openPopup(title, list, status) {
      this.paramTitle = title
      this.paramList = list
      this.paramStatus = status
      this.popup = true
    },
    getMonitorData() {
      let tempCustomerType = ''
      if (this.customerType !== 'A') {
        tempCustomerType = this.customerType
      }

      getMonitoringTotal('', '', tempCustomerType).then(res => {
        if (res.siteTotal) {
          this.siteTotal = new Object()
          this.siteTotal = res.siteTotal
        }
        if (res.inverterTotal) {
          this.inverterTotal = new Object()
          this.inverterTotal = res.inverterTotal
        }
        this.sidoFlag = new Array()
        Object.keys(res.sido).forEach(key => {
          this.sidoFlag.push(key)
        })
        this.sidoData = new Array()
        this.sidoData = res.sido
        this.flag++
      })
    },
    showStock(stock) {
      this.visibility = stock
    },
    getVisibility(show) {
      if (this.sidoFlag === show) {
        return true
      } else if (this.sidoFlag === 'A') {
        return true
      } else {
        return false
      }
    },
    setHeightOfImage() {
      // fitHeightOfElement(this.$refs.img, 450)
    },
    popup2() {
      // 첫 화면에서 팝업을 띄운다
      this.layer_type = 'SummaryPopup'

      let found = false
      let start, end
      let i = 0

      while (i <= document.cookie.length) {
        start = i
        end = start + 'popup'.length
        if (document.cookie.substring(start, end) === 'popup') {
          found = true
          break
        }
        i++
      }

      if (found === true) {
        console.log('cookie found')
        this.component_show = false
      } else {
        console.log('cookie not found')
        this.component_show = true
      }

      // this.component_show = true
    },
    closeLayer() {
      if (document.getElementById('chkToday').checked) {
        let todayDate = new Date()
        todayDate.setDate(todayDate.getDate() + 5)
        document.cookie =
          'popup' +
          '=' +
          escape('no') +
          '; path=/; expires=' +
          todayDate.toGMTString() +
          ';'
        this.component_show = false
      } else {
        this.component_show = false
      }
      // this.$emit('update:component_show', false)
    },
    closePopup(result) {
      if (result.ok) {
        this.modal = false
        this.$router.replace('/mypage')
      } else {
        this.modal = false
        dateRenew(localStore.get('userId'))
        localStore.set('pw_change', '')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.main_card2 {
  background-color: white;

  table {
    font-size: 12px;
    color: black;
    width: 100%;
    border: solid 1px rgb(210, 210, 210);
    border-collapse: collapse;

    tr {
      td {
        text-align: center;
        border: solid 1px rgb(210, 210, 210);
        padding: 0px 0px 0px 0px;
        white-space: pre-line;
      }

      th {
        text-align: center;
        padding-top: 2px;
        padding-bottom: 2px;
        background-color: rgb(225, 230, 236);
      }
    }
  }
}
</style>
<style>
/* .v-responsive__content {
  width: 100% !important;
} */
</style>
